import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import { useLoader } from "../../../utils/LoaderContext";

import PickUpPending from "./GetAllOrders/PickUpPending";
import DownloadedOrders from "./GetAllOrders/DownloadedOrders";

const AllOrders = () => {
  const navigate = useNavigate();
  const [searchText, setSearchText] = useState("");
  const [activeTab, setActiveTab] = useState("notpicked");
  const { setLoading } = useLoader();
  const location = useLocation();

  const tabList = [
    { key: "notpicked", label: "Download Pending", color: "bg-primary" },
    { key: "downloaded", label: "Downloaded Orders", color: "bg-primary" }, // ✅ fixed spelling
  ];

  useEffect(() => {
    setLoading(true);
    const timeout = setTimeout(() => setLoading(false), 500);
    return () => clearTimeout(timeout);
  }, [activeTab, setLoading]);

  useEffect(() => {
    const tabFromURL = new URLSearchParams(location.search).get("tab");
    if (tabFromURL) {
      setActiveTab(tabFromURL);
    } else {
      navigate("?tab=notpicked", { replace: true });
    }
  }, [location.search, navigate]);

  const renderTable = () => {
    switch (activeTab) {
      case "notpicked":
        return <PickUpPending searchText={searchText} />;
      case "downloaded": // ✅ fixed case
        return <DownloadedOrders searchText={searchText} />;
      default:
        return (
          <div className="text-center py-8 text-gray-500">
            Select a tab to view orders
          </div>
        );
    }
  };

  return (
    <div className="flex flex-col h-screen w-full">
      {/* Tabs */}
      <div className="sticky top-0 z-10 bg-white border-b shadow-sm">
        <div className="flex justify-between items-center px-4 py-2 gap-4 flex-wrap" />
        <div className="w-full bg-white border-t">
          <div className="px-4 py-3">
            <div className="flex gap-2 overflow-x-auto hide-scrollbar scroll-smooth">
              {tabList.map((tab) => (
                <button
                  key={tab.key}
                  onClick={() => navigate(`?tab=${tab.key}`)}
                  className={`px-4 py-1 text-sm rounded border transition-all duration-200 whitespace-nowrap
                    ${
                      activeTab === tab.key
                        ? `${tab.color} text-white ring-2 ring-offset-1 ring-white`
                        : "text-primary bg-primaryLight hover:bg-primary hover:text-white border-primary"
                    }`}
                >
                  {tab.label}
                </button>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Content */}
      <div className="flex-1 bg-gray-50 overflow-hidden">
        <div className="h-full p-4 overflow-auto">
          <div className="max-w-full">{renderTable()}</div>
        </div>
      </div>
    </div>
  );
};


export default AllOrders;
